// Words the translator notes quote: HV case and gender names in Finnish and English.

/** HV case codes as "in the … case" (note valencyCase). */
export const CASE_IN_FI: Record<string, string> = {
  nom: 'nominatiivissa',
  acc: 'akkusatiivissa',
  gen: 'genetiivissä',
  dat: 'datiivissa',
  loc: 'lokatiivissa',
  ins: 'instrumentaalissa',
  com: 'komitatiivissa',
  voc: 'vokatiivissa',
};
/** HV case codes as case names (notes framePrep). */
export const CASE_NAME_FI: Record<string, string> = {
  nom: 'nominatiivi',
  acc: 'akkusatiivi',
  gen: 'genetiivi',
  dat: 'datiivi',
  loc: 'lokatiivi',
  ins: 'instrumentaali',
  com: 'komitatiivi',
  voc: 'vokatiivi',
};
export const CASE_IN_EN: Record<string, string> = {
  nom: 'nominative',
  acc: 'accusative',
  gen: 'genitive',
  dat: 'dative',
  loc: 'locative',
  ins: 'instrumental',
  com: 'comitative',
  voc: 'vocative',
};

/** Noun genders (notes borrowedName, referentGender). */
export const GENDER_FI: Record<string, string> = { lunar: 'kuusuku', solar: 'aurinkosuku', terrestrial: 'maasuku', aquatic: 'vesisuku' };
export const GENDER_ADJ_FI: Record<string, string> = {
  lunar: 'kuusukuiseen',
  solar: 'aurinkosukuiseen',
  terrestrial: 'maasukuiseen',
  aquatic: 'vesisukuiseen',
};
export const GENDER_EN: Record<string, string> = { lunar: 'lunar', solar: 'solar', terrestrial: 'terrestrial', aquatic: 'aquatic' };
